import { TextStyle_TextAlignment, PluginContainerData_Alignment, PluginContainerData_Width_Type, DividerData_LineStyle, DividerData_Width, DividerData_Alignment, ButtonData_Type, MapType, HTMLData_Source, PollData_Poll_Settings_Permissions_ViewRole, PollData_Poll_Settings_Permissions_VoteRole, PollData_Layout_PollLayout_Type, PollData_Layout_PollLayout_Direction, PollData_Design_PollDesign_Background_Type, Node_Type } from 'ricos-schema';
import bulletedListDataDefaults from 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import orderedListDataDefaults from 'ricos-schema/dist/statics/ordered_list.defaults.json';
import { dataByNodeType } from '../converters/nodeUtils.js';
import { addNode as addNode$1, toTextDataArray, toListDataArray } from './builder-utils.js';
import '../ReadonlyNonEmptyArray-0e481d0b.js';
import '../string-40bcd6bf.js';
import 'lodash';
import 'uuid';
import '../utils.js';
import '../converters/generateRandomId.js';
import '../Either-48abb652.js';
import '../fp-utils-24a5cc96.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_PARAGRAPH_DATA = {
  textStyle: { textAlignment: TextStyle_TextAlignment.AUTO },
  indentation: 0
};
const DEFAULT_CONTAINER_DATA = {
  alignment: PluginContainerData_Alignment.CENTER,
  textWrap: true,
  width: { size: PluginContainerData_Width_Type.CONTENT }
};
const DEFAULT_DIVIDER_DATA = {
  lineStyle: DividerData_LineStyle.SINGLE,
  width: DividerData_Width.LARGE,
  alignment: DividerData_Alignment.CENTER,
  containerData: __spreadProps(__spreadValues({}, DEFAULT_CONTAINER_DATA), { textWrap: false })
};
const DEFAULT_BUTTON_DATA = {
  type: ButtonData_Type.ACTION,
  containerData: DEFAULT_CONTAINER_DATA,
  text: "Click Me"
};
const DEFAULT_CODE_DATA = {
  textStyle: {
    textAlignment: TextStyle_TextAlignment.AUTO
  }
};
const DEFAULT_HEADING_DATA = {
  level: 2,
  indentation: 0,
  textStyle: { textAlignment: TextStyle_TextAlignment.AUTO }
};
const DEFAULT_MAP_DATA = {
  containerData: DEFAULT_CONTAINER_DATA,
  mapSettings: {
    mapType: MapType.ROADMAP
  }
};
const DEFAULT_HTML_DATA = {
  containerData: DEFAULT_CONTAINER_DATA,
  html: "<div/>",
  url: void 0,
  source: HTMLData_Source.HTML
};
const DEFAULT_POLL_DATA = {
  containerData: DEFAULT_CONTAINER_DATA,
  poll: {
    options: [],
    title: "",
    settings: {
      permissions: {
        view: PollData_Poll_Settings_Permissions_ViewRole.VOTERS,
        vote: PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    }
  },
  layout: {
    poll: {
      type: PollData_Layout_PollLayout_Type.LIST,
      direction: PollData_Layout_PollLayout_Direction.LTR,
      enableImage: false
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: PollData_Design_PollDesign_Background_Type.IMAGE
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};
const createNode = (generateId) => (type, data, nodes) => __spreadProps(__spreadValues({
  id: generateId(),
  type
}, dataByNodeType(type, data)), {
  nodes: nodes || []
});
const createListNode = (generateId) => (type, items, data) => createNode(generateId)(
  type,
  data,
  items.map(
    ({ text, data: data2 }) => createNode(generateId)(Node_Type.LIST_ITEM, {}, [
      createTextNode(generateId)(Node_Type.PARAGRAPH, text, data2)
    ])
  )
);
const createTextNode = (generateId) => (type, text, data) => __spreadProps(__spreadValues({}, createNode(generateId)(type, data)), {
  nodes: text.map((textData) => __spreadValues({
    nodes: [],
    id: "",
    type: Node_Type.TEXT
  }, dataByNodeType(Node_Type.TEXT, textData)))
});
const makeNode = (generateId) => ({ data, type }) => createNode(generateId)(type, data);
const addNode = (generateId) => ({ data, type, index, before, after, content }) => {
  const node = makeNode(generateId)({ type, data });
  return addNode$1({ node, index, before, after, content });
};
const makeTextNode = (generateId) => ({
  text,
  data,
  type
}) => {
  const textData = toTextDataArray(text);
  return createTextNode(generateId)(type, textData, data);
};
const addTextNode = (generateId) => ({
  text,
  data,
  type,
  index,
  before,
  after,
  content
}) => {
  const node = makeTextNode(generateId)({ text, data, type });
  return addNode$1({ node, index, before, after, content });
};
const makeListNode = (generateId) => ({
  items,
  data = DEFAULT_PARAGRAPH_DATA,
  type,
  listData = type === Node_Type.BULLETED_LIST ? bulletedListDataDefaults : orderedListDataDefaults
}) => {
  const listItemData = toListDataArray(items, data);
  return createListNode(generateId)(type, listItemData, listData);
};
const addListNode = (generateId) => ({
  items,
  data,
  listData,
  type,
  index,
  before,
  after,
  content
}) => {
  const node = makeListNode(generateId)({ items, data, type, listData });
  return addNode$1({ node, index, before, after, content });
};

export { DEFAULT_BUTTON_DATA, DEFAULT_CODE_DATA, DEFAULT_CONTAINER_DATA, DEFAULT_DIVIDER_DATA, DEFAULT_HEADING_DATA, DEFAULT_HTML_DATA, DEFAULT_MAP_DATA, DEFAULT_PARAGRAPH_DATA, DEFAULT_POLL_DATA, addListNode, addNode, addTextNode, createListNode, createNode, createTextNode, makeListNode, makeNode, makeTextNode };
//# sourceMappingURL=node-builder-methods.js.map
